const productsData = [
  {
    id: 'cintillo',
    title: 'Cintillo de Autoridad (Header de Alianza)',
    product: 'Co-branding institucional',
    investment: '$80 USD / mes',
    impacts: [
      'Banner de co-branding en la parte superior de la sección Punto de Fe: no publicitario, institucional.',
      'Texto: "Impulsando la conexión espiritual en cada rincón de Venezuela."',
      'Logos Punto de Fe + Movistar unidos. Transmitir que el mensaje de fe viaja gracias a la infraestructura de Movistar.',
    ],
  },
  {
    id: 'tecnologia-servicio',
    title: 'Tecnología al Servicio del Mensaje',
    product: 'Soluciones de Conectividad',
    investment: '$120 USD / mes',
    impacts: [
      'Señal Sin Fronteras: mapa interactivo de cobertura Movistar. "Llevamos Punto de Fe a donde otros no llegan".',
      'Streaming de Alta Fidelidad: TNO Media Lab con fibra óptica y red 4G/5G de Movistar para que la transmisión de fe nunca se interrumpa.',
      'Contenido Data-Lite: sección optimizada para que usuarios Movistar consuman Punto de Fe con el menor consumo de datos posible.',
    ],
  },
  {
    id: 'historias-conexion',
    title: 'Historias de Conexión',
    product: 'Branded Content (Estilo TNO Digest)',
    investment: '$60 USD / mes',
    subtitle: '4 artículos al mes',
    impacts: [
      'Columna de artículos firmados por la marca o en colaboración con las anclas de Punto de Fe.',
      'Ejemplos: "Cómo la tecnología acorta distancias entre la fe y la familia", "El poder de un mensaje: Testimonios que viajaron por la red Movistar", "Innovación con propósito: La digitalización de la espiritualidad".',
      'Movistar se humaniza donde el usuario busca conexión.',
    ],
  },
  {
    id: 'widget-intencion',
    title: 'Tu Intención en la Red',
    product: 'Widget de Interacción',
    investment: '$150 USD / mes',
    impacts: [
      'Simulador de Alcance: el usuario escribe una intención de oración o mensaje positivo.',
      'Respuesta visual: gráfico que muestra cómo ese mensaje "viaja" por las torres de Movistar hasta el set de TNO en vivo.',
      'Call to Action: "Envía tu mensaje. Tu fe nos conecta, Movistar nos une."',
    ],
  },
  {
    id: 'footer-institucional',
    title: 'Footer de Respaldo Institucional (despedida de los programas)',
    product: 'Despedida de los programas',
    investment: '$80 USD / mes',
    impacts: [
      'Al final de la página Punto de Fe, un cierre que sella el acuerdo (despedida de los programas).',
      '"Punto de Fe es una producción de TNO Network, respaldada por la infraestructura tecnológica de Movistar Venezuela. Porque creemos que cada mensaje de esperanza merece la mejor conexión."',
    ],
  },
];

export default productsData;
